export default __webpack_public_path__ + "static/media/lets_talk_btn_violet.d34ebac7.svg";